module.exports = __webpack_public_path__ + "img/arrow-up-green.ca8b038f.svg";